import SettingsApplications from './component'

export default SettingsApplications